export default {"src":"/_next/static/media/reducing-costs.37cf2479.svg","height":868,"width":760,"blurWidth":0,"blurHeight":0};